import { IconButton, TextField, Tooltip } from "@mui/material";
import RemoveIcon from "@mui/icons-material/Remove";
import AddIcon from "@mui/icons-material/Add";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import { useScriptMode } from "../../../contexts/ScriptModeContext";
import { useIsDark } from "../../hatim/soft/SoftKit";

// onComplete verilirse "+"nın yanında hedefi tek dokunuşta doldurma butonu çıkar.
export default function GoalValueControl({ value, onChange, min = 0, max = 9999, onComplete }) {
  const { t } = useScriptMode();
  const dark = useIsDark();
  const dec = () => onChange(Math.max(min, (value || 0) - 1));
  const inc = () => onChange(Math.min(max, (value || 0) + 1));

  return (
    <div className="flex items-center gap-1">
      <IconButton size="small" onClick={dec} aria-label={t("goal_decrease")}>
        <RemoveIcon fontSize="small" />
      </IconButton>
      <TextField
        size="small"
        type="number"
        value={value ?? 0}
        onChange={(e) => {
          const n = parseInt(e.target.value, 10);
          onChange(Number.isFinite(n) ? Math.max(min, Math.min(max, n)) : 0);
        }}
        inputProps={{ min, max, style: { textAlign: "center", width: 60 }, "aria-label": t("goal_value") }}
      />
      <IconButton size="small" onClick={inc} aria-label={t("goal_increase")}>
        <AddIcon fontSize="small" />
      </IconButton>
      {onComplete && (
        <Tooltip title={t("goal_complete")}>
          <span>
            <IconButton size="small" onClick={onComplete} aria-label={t("goal_complete")} sx={{ color: dark ? "#8FC9CA" : "#006A71" }}>
              <DoneAllIcon fontSize="small" />
            </IconButton>
          </span>
        </Tooltip>
      )}
    </div>
  );
}
